import { useCallback } from 'react';

import { Button } from '@mui/material';

import { useRouter } from 'src/routes/hooks';

import { useAuthContext } from 'src/auth/hooks';
import { signOut } from 'src/auth/context/jwt/action';

export function SignOutButton({ onClose }) {
  const router = useRouter();
  const { checkUserSession } = useAuthContext();

  const handleLogout = useCallback(async () => {
    try {
      await signOut();
      checkUserSession();
      onClose();
      router.push('/auth/sign-in');
    } catch (error) {
      console.error('Logout failed', error);
    }
  }, [checkUserSession, onClose, router]);

  return (
    <Button
      fullWidth
      variant="outlined"
      color="inherit"
      onClick={handleLogout}
    >
      Sign Out
    </Button>
  );
}